/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';
import { orderBy } from 'lodash';

import ExcludedCourt from './ExcludedCourt';

import styles from '../drawEdit.scss';

const _ = { orderBy };

const LocationsTabV2 = (props) => {
    const { facilities, selectedFacility, ...restProps } = props;
    const drawEdit = useSelector(({ drawEdit }) => drawEdit);
    const sortedFacilities = _.orderBy(facilities || [], [f => f.name?.toLowerCase()]);
    const clubId = drawEdit.event.data?.club?.id;

    return (
        <div className={`${styles.section} bg-transparent main-content`}>
            <div className={`container mt32 bg-transparent`}>
                {drawEdit.locations.loading && (
                    <div className="row">
                        <div className="col-12" data-testid="locations.loading">
                            <i className="fas fa-circle-notch fa-spin" /> Loading...
                        </div>
                    </div>
                )}
                {!drawEdit.locations.loading && (
                    sortedFacilities.length ? (
                        <div className="row">
                            <div className="col-md-4">
                                {_.orderBy((sortedFacilities[selectedFacility]?.courts || []), [c => c.name?.toLowerCase()]).map(court => (
                                    <ExcludedCourt
                                        key={court.id}
                                        court={court}
                                        {...restProps}
                                    />
                                ))}
                            </div>
                            <div className="col-md-4">
                                {_.orderBy((sortedFacilities[selectedFacility + 1]?.courts || []), [c => c.name?.toLowerCase()]).map(court => (
                                    <ExcludedCourt
                                        key={court.id}
                                        court={court}
                                        {...restProps}
                                    />
                                ))}
                            </div>
                            <div className="col-md-4">
                                {_.orderBy((sortedFacilities[selectedFacility + 2]?.courts || []), [c => c.name?.toLowerCase()]).map(court => (
                                    <ExcludedCourt
                                        key={court.id}
                                        court={court}
                                        {...restProps}
                                    />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-4" data-testid="locations.empty-msg">To use this location and facility to schedule your matches, please add courts to your facility from your club profile under "locations and courts".</p>
                                <u className="cursor-pointer" onClick={() => props.history.push(`/clubs/${clubId}`)} data-testid="locations.club-profile-link">Club Profile</u>
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default LocationsTabV2;
